module.exports = "/assets/data/dd6001938b30fd607193c564b16e6de9-BA9.data.json";